import {
    Box,
    Image,
    Flex
} from '@chakra-ui/react'
import { colors } from 'src/common/colors'
import { ChevronRightIcon } from "@chakra-ui/icons"
import { ClubData } from "src/hooks/SearchInfo/useGetClubs"
import styled from 'styled-components'

type Props = {
    club: ClubData
}

export const ClubBox = (props: Props) => {
    const { club } = props;

    return (
        <>
            <Flex
                alignItems='center'
                justifyContent='space-between'
            >
                <Flex>
                    <Box
                        width='73px'
                        height='73px'
                        border={`2px solid ${colors.button.blue}`}
                        borderRadius='50%'
                        overflow='hidden'
                        marginRight='18px'
                    >
                        <Image
                            width='100%'
                            height='100%'
                            objectFit='cover'
                            src={club.academyImageUrl}
                            alt={club.academyName}
                        />
                    </Box>
                    <Flex direction='column' justifyContent='center'>
                        <ClubDetailBox 
                            fontFamily='NanumSquareNeoEBold' 
                            color={`${colors.darkBlue}`} 
                            fontSize='24px' 
                            lineHeight='162%'
                        >
                            {club.academyName}
                        </ClubDetailBox>
                        <ClubDetailBox
                            fontSize="16px"
                            lineHeight="162%"
                            color={`${colors.button.blue}`}
                        >
                            {club.academyAddress}
                        </ClubDetailBox>
                    </Flex>
                </Flex>
                <ChevronRightIcon
                    position='relative'
                    right='0'
                    boxSize='48px'
                    flexShrink='0'
                    color={colors.button.blue}
                />
            </Flex>
        </>
    )
}

const ClubDetailBox = styled(Box)`
    @media (max-width: 1510px) {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`